module.exports = __webpack_public_path__ + "img/question-diamond-fill.41304715.svg";